module.exports = __webpack_public_path__ + "img/pool-and-bio-pool-text.0bf8ffc6.svg";